export default "__VITE_ASSET__BkVInKeQ__"